export interface EquipmentModel {
    System: string;
    LogicalName: string;
    EquipmentHq: string;
    EquipmentRu: string;
    PartNo: string;
    SerialNo: string;
    IStatus: string;
    HcStatus: string;
    Type: string;
    DivId: string;
    Description: string;
    OrderNumber: string;
    HcPurOrder: string;
    HcDelDate: string;
    HcCountry: string;
    HcSalesArea: string;
    HcSalesGrp: string;
    HcLanguage: string;
    Location: string;
    Name1: string;
    Name2: string;
    Department: string;
    Street: string;
    Country: string;
    Address: string;
    HcShiptoLoc: string;
    StName1: string;
    StName2: string;
    StStreet: string;
    StCountry: string;
    StAddress: string;
    Dup: string;
    User: string;
}

export const initialEquipmentModel: EquipmentModel = {
    Address: '',
    Country: '',
    Department: '',
    Description: '',
    DivId: '',
    Dup: '',
    EquipmentHq: '',
    EquipmentRu: '',
    HcCountry: '',
    HcDelDate: '',
    HcLanguage: '',
    HcPurOrder: '',
    HcSalesArea: '',
    HcSalesGrp: '',
    HcShiptoLoc: '',
    HcStatus: '',
    IStatus: '',
    Location: '',
    LogicalName: '',
    Name1: '',
    Name2: '',
    OrderNumber: '',
    PartNo: '',
    SerialNo: '',
    StAddress: '',
    StCountry: '',
    StName1: '',
    StName2: '',
    StStreet: '',
    Street: '',
    System: '',
    Type: '',
    User: '',
};
